export default function PartnershipsOverview() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Content */}
        <div>
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            Partnership Overview
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-6">
            A Platform Built on Relationships, Education &amp; Shared Purpose
          </h2>
          <p className="text-[#6B6B6B] text-base leading-relaxed mb-5">
            Harambee Global Ventures is building a relationship-driven platform at the intersection of financial education, advisory services, and long-term wealth-building for the African Diaspora. Partnerships are not peripheral to our mission &mdash; they are central to it.
          </p>
          <p className="text-[#6B6B6B] text-base leading-relaxed mb-8">
            We believe that meaningful, lasting impact is built through aligned collaboration. By working with institutions, community organizations, diaspora networks, and mission-driven ventures, we expand our reach, deepen our credibility, and create more pathways for the communities we serve to access education, advisory support, and long-term opportunity.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {[
              {
                icon: "ri-heart-line",
                title: "Trust-First Approach",
                desc: "Every partnership begins with shared values and a genuine alignment of mission and purpose.",
              },
              {
                icon: "ri-expand-left-right-line",
                title: "Expanded Reach",
                desc: "Together we reach more communities, more families, and more aspiring investors across the diaspora.",
              },
              {
                icon: "ri-award-line",
                title: "Credibility &amp; Accountability",
                desc: "Strategic partnerships strengthen our platform&apos;s credibility and commitment to responsible growth.",
              },
              {
                icon: "ri-plant-line",
                title: "Long-Term Value",
                desc: "We build for the long term &mdash; structured collaborations designed to create lasting, shared impact.",
              },
            ].map((item) => (
              <div key={item.title} className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 flex-shrink-0 mt-0.5">
                  <i className={`${item.icon} text-[#1A4D3C] text-base`} />
                </div>
                <div>
                  <div
                    className="font-semibold text-[#2B2D2F] text-sm mb-1"
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  />
                  <div
                    className="text-[#6B6B6B] text-xs leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: item.desc }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Image */}
        <div className="relative">
          <img
            src="/assets/images/site/part-overview-001-800x700.jpg"
            alt="Harambee Global Ventures partnership collaboration cross-border"
            className="w-full h-[520px] object-cover object-top rounded-lg"
          />
          {/* Floating accent card */}
          <div className="absolute -bottom-6 -left-6 bg-[#1A4D3C] text-white rounded-lg p-6 max-w-[230px] hidden md:block">
            <div className="font-['Cormorant_Garamond'] text-3xl font-bold text-[#C9A961] mb-1">
              Aligned
            </div>
            <div className="text-white/70 text-xs leading-relaxed">
              Partnerships built on shared values, mutual trust, and a common commitment to diaspora-centered impact
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
